import { configureWithRelationshipSerializer, configurePaginatedSerializer } from './utils';

const EventSerializer = configureWithRelationshipSerializer({ idToInt: true });

const PaginatedEventSerializer = configurePaginatedSerializer({ baseSerializer: EventSerializer });

export default {
  event: EventSerializer,
  paginatedEvents: PaginatedEventSerializer,
};
